import { FieldType, Mandatory } from '90.quickConnect.Models/enums';
import { isEmptyFieldValue } from '90.quickConnect.Models/guards';
import { FieldDesc } from '90.quickConnect.Models/models';

export function fieldIsMandatory({ items, mandatory, isVisible }: FieldDesc): boolean {
  if (!items || items.length === 0) return mandatory === Mandatory.Required && isVisible;

  return items.some(fieldIsMandatory);
}

/**
 * True si tous les champs Required, visibles et non CheckBox
 * dans ce champ et ses descendants ont une valeur.
 * S’il n’y a AUCUN Required trouvé retourne true.
 */
export function allRequiredHaveValues(field: FieldDesc): boolean {
  const check = (node: FieldDesc): { found: boolean; allFilled: boolean } => {
    // obligatoire applicable
    const isReq =
      node.isVisible === true && node.mandatory === Mandatory.Required && node.fieldType !== FieldType.CheckBox;

    // si obligatoire, considéré "rempli" si la valeur n'est pas vide
    const selfFound = isReq;
    const selfFilled = isReq ? !isEmptyFieldValue(node.value) : true;

    // descendre récursivement si items
    if (node.items && node.items.length > 0) {
      return node.items.reduce(
        (acc, child) => {
          const r = check(child);
          return {
            found: acc.found || r.found,
            allFilled: acc.allFilled && r.allFilled,
          };
        },
        { found: selfFound, allFilled: selfFilled },
      );
    }

    return { found: selfFound, allFilled: selfFilled };
  };

  const result = check(field);
  // S'il n'y a pas d'obligatoires, c'est OK par défaut
  return result.found ? result.allFilled : true;
}
